module.exports = __webpack_public_path__ + "img/primary-home.bbb87804.svg";